var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsFullMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47,20.0351562c0-1.6660156-1.3017578-3.0576172-2.9638672-3.1689453l-12.3583984-0.8232422L26.3134766,3.5263672 C25.9169922,2.5986328,25.0087891,2,24,2s-1.9169922,0.5986328-2.3125134,1.5253906l-5.365221,12.5175781L3.9638672,16.8662109 C2.3017578,16.9775391,1,18.3691406,1,20.0351562c0,0.8955078,0.3808594,1.7539062,1.0449219,2.3535156l9.34375,8.4541016 L8.078125,44.5585938C8.0263672,44.7724609,8,44.9921875,8,45.2128906C8,46.75,9.25,48,10.7871094,48h0.1367188 c0.5878906,0,1.1513672-0.1816406,1.6279297-0.5253906L24,39.2324219l11.4482422,8.2421875 C35.9248047,47.8183594,36.4882812,48,37.0761719,48h0.1367188C38.75,48,40,46.75,40,45.2128906 c0-0.2207031-0.0263672-0.4404297-0.078125-0.6542969l-3.3105469-13.7158203l9.34375-8.453125 C46.6191406,21.7890625,47,20.9306641,47,20.0351562z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsFullMedium);
export default __webpack_public_path__ + "static/media/reviews-full--medium.c3ebb6468078688f68a07a305a1bc2bf.svg";
export { ForwardRef as ReactComponent };